var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLessonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 68.5,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5 81V51H91.5V81H49.5ZM46.5 49C46.5 48.4477 46.9477 48 47.5 48H93.5C94.0523 48 94.5 48.4477 94.5 49V83C94.5 83.5523 94.0523 84 93.5 84H47.5C46.9477 84 46.5 83.5523 46.5 83V49ZM46.5 89.5C45.6716 89.5 45 90.1716 45 91C45 91.8284 45.6716 92.5 46.5 92.5H94.5C95.3284 92.5 96 91.8284 96 91C96 90.1716 95.3284 89.5 94.5 89.5H46.5Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLessonCircle);
export default __webpack_public_path__ + "static/media/icon_lesson_circle.ff78b07e48a5662df69019c4e4db4387.svg";
export { ForwardRef as ReactComponent };